<div class="container-fluid mt-4">
  <div class="row">
    <div class="col-12">
      <h2 class="subtitle-page">Datos Receptor</h2>
    </div>
  </div>

  <div class="row" #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
    <form [formGroup]="formReceptor">
      <div class="col-12 mt-3">
        <div class="row">
          <div class="col-xxl-3 col-md-4 mb-2">
            <label class="label-form">RFC <i class="fas fa-asterisk text-danger"></i></label>
            <input type="text" class="form-control rfc" (input)="sendDataReceptor()" formControlName="rfc" maxlength="13"/>
          </div>
          <div class="col-xxl-3 col-md-4 mb-2">
            <label class="label-form">Nombre <i class="fas fa-asterisk text-danger"></i></label>
            <input type="text" class="form-control" (input)="sendDataReceptor()" formControlName="nombre" />
          </div>
          <div class="col-xxl-3 col-md-4 mb-2">
            <label class="label-form">Uso CFDI <i class="fas fa-asterisk text-danger"></i></label>
            <select2 (update)="sendDataReceptor()" class="custom-select2" (open)="this.formReceptor.controls['usoCFDI'].markAsTouched()" [data]="customListCatMetodoPago" infiniteScroll formControlName="usoCFDI"></select2>
              <!-- <app-select-search  [listOptions]="listCatUsoCFDI" labelSelect="Descripcion" valueSelect="c_UsoCFDI" formControlName="usoCFDI" (ngModelChange)="sendDataReceptor()"></app-select-search> -->
              
          </div>
          <div class="col-xxl-3 col-md-4 mb-2">
            <label class="label-form">Régimen Fiscal <i class="fas fa-asterisk text-danger"></i></label>
            @if (isLoading_usoRegimen){
              <!-- <app-select-search  [listOptions]="listCatRegimenFiscal" labelSelect="Descripcion" valueSelect="c_RegimenFiscal"  formControlName="regimenFiscal" (ngModelChange)="sendDataReceptor()"></app-select-search> -->
              <select2 (update)="sendDataReceptor()" class="custom-select2" (open)="this.formReceptor.controls['regimenFiscal'].markAsTouched()" [data]="customListRegimen" infiniteScroll formControlName="regimenFiscal"></select2>
              } @else {
                      <span class="visually-hidden">Loading...</span>
              }
          </div>
          <div class="col-xxl-3 col-md-4 mb-2">
            <label class="label-form">Email </label>
            <input type="text" class="form-control" (input)="sendDataReceptor()" formControlName="email" />
          </div>
          <div class="col-xxl-3 col-md-4 mb-2">
            <div class="row">
              <div class="col">
                <label class="label-form">Codigo Postal <i class="fas fa-asterisk text-danger"></i></label>
                <input type="text" inputmode="numeric" maxlength="6" class="form-control" (input)="onInputChange($event)" formControlName="domicilioFiscal" />
              </div>
              <div class="col">
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>